import { render } from "./StatisticsManagement.vue?vue&type=template&id=6e67c612&scoped=true"
import script from "./StatisticsManagement.vue?vue&type=script&lang=js"
export * from "./StatisticsManagement.vue?vue&type=script&lang=js"

import "./StatisticsManagement.vue?vue&type=style&index=0&id=6e67c612&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e67c612"]])

export default __exports__